import { Button } from "@tredespace/ui/widgets";
import type { JSX } from "react";
import {
  popSelectedStandard,
  removeSelectedStandard,
  stackSelectedStandard,
} from "../state/engine/engine.actions.ts";
import { selectionState } from "../state/selection/selection.state.ts";
import { toolState } from "../state/tool/tool.state.ts";

/** Actions for the standard the Standard tool has selected. */
export function LegSelection(): JSX.Element | null {
  const { leg } = selectionState.use();
  const { size } = toolState.use();

  if (!leg) {
    return null;
  }

  const height = leg.height.toLocaleString("en", { minimumFractionDigits: 1 });
  const stackLabel = (size / 1000).toLocaleString("en", { minimumFractionDigits: 1 });

  return (
    <div className="absolute inset-x-0 bottom-3 flex justify-center">
      <div className="flex items-center gap-2 rounded-md bg-slate-900/95 px-3 py-2 text-xs text-slate-100 shadow-lg ring-1 ring-slate-100/10">
        <span className="font-mono">
          ({leg.x.toFixed(2)} · {leg.z.toFixed(2)})
        </span>
        <span className="font-mono text-slate-400">
          {leg.segments.join(" + ")} = {height} m
        </span>
        <Button onClick={() => stackSelectedStandard(size)}>+ stack {stackLabel} m</Button>
        <Button onClick={popSelectedStandard}>− remove top</Button>
        <Button onClick={removeSelectedStandard}>Remove</Button>
      </div>
    </div>
  );
}
